import { render, staticRenderFns } from "./UnsavedM.vue?vue&type=template&id=2fc3288d&scoped=true&"
import script from "./UnsavedM.vue?vue&type=script&lang=js&"
export * from "./UnsavedM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc3288d",
  null
  
)

export default component.exports